import React, { useState, useEffect } from "react";
import { MDBContainer } from "mdbreact";

import Banner from "../../../template/Banner";
import ShareBtns from "../../../template/ShareBtns";
import Loader from "../../../template/Loader";

import api from "../../../../services/api";

import "./styles.css";

export default () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async function fetchData() {
      setLoading(true);

      try {
        const { data } = await api.get("/transparency");

        if (data.success) {
          setData(data.data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const description =
    "Lorem ipsum dolor sit, amet consectetur adipisicing elit.";

  return (
    <div className="transparencia">
      <Banner title="TRANSPARÊNCIA" subtitle={description} />

      <MDBContainer className="mt-4">
        <ShareBtns title={document.title} description={description} />
      </MDBContainer>

      <div className="content container d-flex justify-content-center align-items-center flex-column">
        <h1>LOREM IPSUM</h1>
        <p>
          Lorem ipsum dolor, sit amet consectetur adipisicing elit. Cumque natus
          accusantium qui labore molestias. Consequuntur totam eaque vero
          suscipit fuga reprehenderit sit quia aspernatur, neque iusto optio, ab
          sed possimus?
        </p>

        {loading ? (
          <Loader />
        ) : (
          <div className="files d-flex flex-column align-self-start">
            <ul>
              {data.map((item) => (
                <li item={item}>
                  <a
                    href={item.file_url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};
